module.exports = __webpack_public_path__ + "static/media/DigitalCardMockupGoogleFull.e676e074.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/DigitalCardMockupGoogleFull.png
// module id = 6126
// module chunks = 1